export default function ArrowIcon({ label = 'Šipka', ...restProps }) {
	return (
		<svg
			version='1.1'
			viewBox='0 0 24 24'
			aria-label={label}
			focusable={false}
			xmlns='http://www.w3.org/2000/svg'
			{...restProps}
		>
			<path
				fill='currentColor'
				transform='rotate(90 5.5 13.5)'
				d='M.314 12.625l5.47-5.47-5.47-5.47A.75.75 0 011.375.626l6.53 6.53-6.53 6.53a.75.75 0 01-1.06-1.06z'
			/>
		</svg>
	);
}
